import { isBrowser } from './is-browser';
/**
 * Проверяет наличие ключа в INITIAL_STATE
 * @param name
 */
export function hasInitialState(name) {
    var _a;
    return isBrowser() && !!((_a = window.INITIAL_STATE) === null || _a === void 0 ? void 0 : _a[name]);
}
/**
 * Получает данные из INITIAL_STATE по ключу
 * @param name
 */
export const getInitialState = (name) => {
    var _a;
    if (isBrowser()) {
        const state = (_a = window.INITIAL_STATE) === null || _a === void 0 ? void 0 : _a[name];
        if (state) {
            return state;
        }
    }
    return {};
};
export const removeInitialState = (name) => {
    var _a;
    if (isBrowser() && ((_a = window.INITIAL_STATE) === null || _a === void 0 ? void 0 : _a[name])) {
        delete window.INITIAL_STATE[name];
    }
};
